import _ from "lodash";
import update from "immutability-helper";

const NAME = "UnitFlow";
const SET_ASSIGNMENT_MODAL_DATA = `SET_ASSIGNMENT_MODAL_DATA_${NAME}`;
const SET_ASSESSMENT_IMPORT_MODAL_DATA = `SET_ASSESSMENT_IMPORT_MODAL_DATA_${NAME}`;
const SET_ASSESSMENT_SELECT_MODAL_DATA = `SET_ASSESSMENT_SELECT_MODAL_DATA_${NAME}`;
const SET_ADD_NOTE_MODAL_DATA = `SET_ADD_NOTE_MODAL_DATA_${NAME}`;
const SET_WORKSHEET_MODAL_DATA = `SET_WORKSHEET_MODAL_DATA_${NAME}`;
const SET_ADD_LINK_MODAL_DATA = `SET_ADD_LINK_MODAL_DATA_${NAME}`;
const SET_ACTIVE_CONTENT_DATA = `SET_SECTION_CREATION_${NAME}`;
const UPDATE_DISPLAY_SETTINGS = `UPDATE_DISPLAY_SETTINGS_${NAME}`;
const UPDATE_FILTERS = `UPDATE_FILTERS_${NAME}`;
const RESET_FILTERS = `RESET_FILTERS_${NAME}`;
const RESET_MODAL_STATE = `RESET_MODAL_STATE_${NAME}`;
const SET_RIGHT_PANE_ITEMS = `SET_RIGHT_PANE_ITEMS_${NAME}`;
const SET_ACTION_LOADING = `SET_ACTION_LOADING_${NAME}`;
const SET_MOVE_TO_SECTION_MODAL_DATA = `SET_MOVE_TO_SECTION_MODAL_DATA_${NAME}`;
const SET_CONFIRM_MODAL_DATA = `SET_CONFIRM_MODAL_DATA_${NAME}`;
const SET_IS_DRAG_DISABLED = `SET_IS_DRAG_DISABLED_${NAME}`;
const SET_CURRENT_RIGHT_PANE = `SET_CURRENT_RIGHT_PANE_${NAME}`;
const SET_OPEN_ASSESSMENT_PANE_ON_MOUNT = `SET_OPEN_ASSESSMENT_PANE_ON_MOUNT_${NAME}`;

export const initialState = {
  assignmentModalData: {},
  assessmentImportModalData: {},
  assessmentSelectModalData: {},
  addNoteModalData: {},
  worksheetModalData: {},
  addLinkModalData: {},
  activeContentData: {},
  isActionLoading: false,
  displaySettings: {
    show_outline: true,
    show_blueprint_lock: true,
    collapse_all_sections: false,
    collapse_expand_action_nonce: 0,
    expand_all_sections: true,
    thumbnail_image: true,
    task_resource_type: false,
    task_status: true,
    grading_period: true,
    assessment_category: true,
    add_to_top: false,
    add_to_bottom: true,
  },
  filters: {
    selectedItemTypes: [],
    selectedAddedBy: [],
    searchText: "",
    selectedTaskTypeIds: [],
  },
  rightPaneItems: {},
  isDragDisabled: false,
  moveToSectionModalData: {},
  confirmationDialogData: {},
  currentRightPane: false,
  openAssessmentAIPaneOnMount: false,
};

export const setAssignmentModalData = data => ({
  type: SET_ASSIGNMENT_MODAL_DATA,
  data,
});

export const setAssessmentImportModalData = data => ({
  type: SET_ASSESSMENT_IMPORT_MODAL_DATA,
  data,
});

export const setAssessmentSelectModalData = data => ({
  type: SET_ASSESSMENT_SELECT_MODAL_DATA,
  data,
});

export const setAddNoteModalData = data => ({
  type: SET_ADD_NOTE_MODAL_DATA,
  data,
});

export const setWorksheetModalData = data => ({
  type: SET_WORKSHEET_MODAL_DATA,
  data,
});

export const setAddLinkModalData = data => ({
  type: SET_ADD_LINK_MODAL_DATA,
  data,
});

export const setActiveContentData = data => ({
  type: SET_ACTIVE_CONTENT_DATA,
  data,
});

export const updateDisplaySettings = data => {
  return {
    type: UPDATE_DISPLAY_SETTINGS,
    data,
  };
};

export const updateFilters = data => {
  return {
    type: UPDATE_FILTERS,
    data,
  };
};

export const resetFilters = () => {
  return {
    type: RESET_FILTERS,
  };
};

export const resetModalState = () => {
  return {
    type: RESET_MODAL_STATE,
  };
};

export const setRightPaneItems = data => {
  return {
    type: SET_RIGHT_PANE_ITEMS,
    data: data,
  };
};

export const setIsActionLoading = data => ({
  type: SET_ACTION_LOADING,
  data,
});

export const setMoveToSectionModalData = data => ({
  type: SET_MOVE_TO_SECTION_MODAL_DATA,
  data,
});

export const setConfirmationDialogData = data => ({
  type: SET_CONFIRM_MODAL_DATA,
  data,
});

export const setIsDragDisabled = data => ({
  type: SET_IS_DRAG_DISABLED,
  data,
});

export const setCurrentRightPane = data => ({
  type: SET_CURRENT_RIGHT_PANE,
  data,
});

export const setOpenAssessmentAIPaneOnMount = data => ({
  type: SET_OPEN_ASSESSMENT_PANE_ON_MOUNT,
  data,
});

const REDUCER_HANDLERS = {
  [SET_ASSIGNMENT_MODAL_DATA]: (state, action) => {
    return update(state, { assignmentModalData: { $set: action.data } });
  },
  [SET_ASSESSMENT_IMPORT_MODAL_DATA]: (state, action) => {
    return update(state, { assessmentImportModalData: { $set: action.data } });
  },
  [SET_ASSESSMENT_SELECT_MODAL_DATA]: (state, action) => {
    return update(state, { assessmentSelectModalData: { $set: action.data } });
  },
  [SET_ADD_NOTE_MODAL_DATA]: (state, action) => {
    return update(state, { addNoteModalData: { $set: action.data } });
  },
  [SET_WORKSHEET_MODAL_DATA]: (state, action) => {
    return update(state, { worksheetModalData: { $set: action.data } });
  },
  [SET_ADD_LINK_MODAL_DATA]: (state, action) => {
    return update(state, { addLinkModalData: { $set: action.data } });
  },
  [SET_ACTIVE_CONTENT_DATA]: (state, action) => {
    return update(state, { activeContentData: { $set: action.data } });
  },
  [UPDATE_DISPLAY_SETTINGS]: (state, action) => {
    return update(state, { displaySettings: { $set: action.data } });
  },
  [SET_RIGHT_PANE_ITEMS]: (state, action) => {
    return update(state, { rightPaneItems: { $set: action.data } });
  },
  [UPDATE_FILTERS]: (state, action) => {
    const params = action.data;
    _.map(Object.keys(params), key => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });

    return state;
  },
  [RESET_FILTERS]: state => {
    return update(state, {
      filters: { $set: initialState.filters },
    });
  },
  [RESET_MODAL_STATE]: () => {
    return initialState;
  },
  [SET_ACTION_LOADING]: (state, action) => {
    return update(state, { isActionLoading: { $set: action.data } });
  },
  [SET_MOVE_TO_SECTION_MODAL_DATA]: (state, action) => {
    return update(state, { moveToSectionModalData: { $set: action.data } });
  },
  [SET_CONFIRM_MODAL_DATA]: (state, action) => {
    return update(state, { confirmationDialogData: { $set: action.data } });
  },
  [SET_IS_DRAG_DISABLED]: (state, action) => {
    return update(state, { isDragDisabled: { $set: action.data } });
  },
  [SET_CURRENT_RIGHT_PANE]: (state, action) => {
    return update(state, { currentRightPane: { $set: action.data } });
  },
  [SET_OPEN_ASSESSMENT_PANE_ON_MOUNT]: (state, action) => {
    return update(state, {
      openAssessmentAIPaneOnMount: { $set: action.data },
    });
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
